import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

export const Container = styleWithOrgDesign(styled.div`
    padding: 24px;
    background-color: white;
`)

export const Title = styled.h2`
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
`
